import React, {useEffect, useState} from 'react';
import Wrapper from '../../components/Wrapper';
import DashboardHeader from '../../components/DashboardHeader';
import Input from '../../components/Input';
import {useNavigate} from 'react-router-dom';
import Select from 'react-select';
import {useGetRevisions} from '../EquipmentType/model/revisions/getRevisions';
import {
  useAgencyInspectionEnableMutation,
  useAgencyWaterTestKitTypesQuery,
  useExtendAgencyTrialMutation,
  useGetAgencyQuery,
  useGetInspectionQuery,
  useGetTimezonesQuery,
  useInviteFboMutation,
  useLazyCorporateListQuery,
  useLazyGetAgencySubscribedQuery,
  useStartAgencyTrialMutation,
} from '../../store/builder/inspections.api';
import {setLoader} from '../../store/builder/reducer';
import {useDispatch, useSelector} from 'react-redux';
import Modal from '../../components/Modal';
import './index.scss';
import {useErrorHandler} from '../../global/ErrorsHandler';
import {Helmet} from 'react-helmet';
import Cropper from 'react-cropper';
import {toast} from 'react-toastify';
import CustomPaginate from '../../components/PaginateComponent';
import moment from 'moment/moment';
import AgencyRow from '../../components/AgencyRow';
import {useDebounce} from '../LogSheets/hooks';
import Datepicker from '../../components/Datepicker';
import EditPricingModal from '../../components/EditPricingModal';
import {setAgenciesList} from '../../store/builder/agenciesListSlice';
import AgencyTableCard from '../../components/AgencyTableCard';
import {validationEmail} from '../../global/validate';
import useLoader from '../../global/UseLoadingHandler';
import {useTranslation} from '../../hooks/useTranslation';

export default function Agancy() {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const [inviteModal, setInviteModal] = useState(false);
  const [email, setEmail] = useState('');
  const [createModalStatus, setCreateModalStatus] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [list, setList] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [chosenPhoto, setChosenPhoto] = useState(null);
  const [photo, setPhoto] = useState(null);
  const [cropper, setCropper] = useState();
  const [imageBlob, setImageBlob] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentAgency, setCurrentAgency] = useState(null);
  const [search, setSearch] = useState('');
  const debouncedSearchValue = useDebounce(search, 500);
  const [startTrialStatus, setStartTrialStatus] = useState(false);
  const [trialDate, setTrialDate] = useState(null);
  const [startTrialDate, setStartTrialDate] = useState(null);
  const [editPrisingModal, setEditPrisingModal] = useState(false);
  const [inspectionStart, setInspectionStart] = useState(null);
  const [turnOffStatus, setTurnOffStatus] = useState(false);

  // Filter states
  const [inspectionsRevisionFilter, setInspectionsRevisionFilter] = useState(null);
  const [corporateIdFilter, setCorporateIdFilter] = useState(null);
  const [inspectionEnabledFilter, setInspectionEnabledFilter] = useState(null);
  const [customInspectionsEnabledFilter, setCustomInspectionsEnabledFilter] = useState(null);

  // Filter options
  const enabledOptions = [
    { value: '', label: t('agency.filters.all') },
    { value: 'true', label: t('agency.filters.on') },
    { value: 'false', label: t('agency.filters.off') },
  ];

  const [getRevisions, revisionOptions] = useGetRevisions();

  const [
    getAgency,
    {
      data: agencyData,
      error: agencyError,
      isFetching: agencyIsLoading,
      isSuccess: agencyIsSuccess,
      isError: agencyIsError,
    },
  ] = useLazyGetAgencySubscribedQuery();

  const {
    data: timezonesData,
    error: timezonesError,
    isLoading: timezonesIsLoading,
    isSuccess: timezonesIsSuccess,
    isError: timezonesIsError,
  } = useGetTimezonesQuery();

  const [
    getCorporateList,
    {
      data: corporateListData,
      error: corporateListError,
      isFetching: corporateListIsLoading,
      isSuccess: corporateListIsSuccess,
      isError: corporateListIsError,
    },
  ] = useLazyCorporateListQuery();

  const {
    data: waterKitData,
    error: waterKitError,
    isLoading: waterKitIsLoading,
    isSuccess: waterKitIsSuccess,
    isError: waterKitIsError,
  } = useAgencyWaterTestKitTypesQuery();

  const [
    startTrial,
    {
      data: startTrialData,
      isError: startTrialIsError,
      isFetching: startTrialIsLoading,
      isSuccess: startTrialIsSuccess,
      error: startTrialError,
    },
  ] = useStartAgencyTrialMutation();

  const [
    enableInspections,
    {
      data: enableInspectionsData,
      error: enableInspectionsError,
      isFetching: enableInspectionsIsLoading,
      isSuccess: enableInspectionsIsSuccess,
      isError: enableInspectionsIsError,
    },
  ] = useAgencyInspectionEnableMutation();

  const [
    invite,
    {
      data: inviteData,
      isLoading: inviteIsLoading,
      isError: inviteIsError,
      error: inviteError,
      isSuccess: inviteIsSuccess,
    },
  ] = useInviteFboMutation();

  const [errorHandler, setErrorHandler] = useErrorHandler([
    agencyError,
    startTrialError,
    enableInspectionsError,
    inviteIsError,
  ]);
  useLoader([
    inviteIsLoading,
    agencyIsLoading,
    startTrialIsLoading,
    enableInspectionsIsLoading,
  ]);
  useEffect(() => {
    if (
      startTrialStatus ||
      editPrisingModal ||
      turnOffStatus ||
      showModal ||
      createModalStatus ||
      inviteModal
    ) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [
    startTrialStatus,
    editPrisingModal,
    turnOffStatus,
    showModal,
    createModalStatus,
    inviteModal,
  ]);

  useEffect(() => {
    getCorporateList({status: 'active'});
  }, []);

  useEffect(() => {
    getAgency({
      page: currentPage, 
      search: debouncedSearchValue,
      inspections_revision: inspectionsRevisionFilter?.value || '', 
      corporate_id: corporateIdFilter?.value || '', 
      inspection_enabled: inspectionEnabledFilter?.value || '', 
      custom_inspections_enabled: customInspectionsEnabledFilter?.value || ''
    });
  }, [debouncedSearchValue, currentPage, inspectionsRevisionFilter, corporateIdFilter, inspectionEnabledFilter, customInspectionsEnabledFilter]);

  useEffect(() => {
    getRevisions(false, true);
  }, []);

  useEffect(() => {
    if (inviteIsSuccess) {
      toast.success(t('agency.messages.inviteSuccess'));
      setInviteModal(false);
    }
    if (inviteIsError) {
      toast.error(inviteError?.data?.email[0]);
    }
  }, [inviteIsSuccess, inviteIsError, t]);

  useEffect(() => {
    if (agencyData) {
      setList(agencyData?.data?.map(item => ({...item, action_status: false})));
      dispatch(setAgenciesList(agencyData?.data));
    }
  }, [agencyData]);

  useEffect(() => {
    if (!userInfo?.is_global) {
      navigate('/inspections');
    }
  }, [userInfo]);

  useEffect(() => {
    if (createModalStatus || startTrialStatus) {
      document.querySelector('html').style.overflow = 'hidden';
    } else {
      document.querySelector('html').style.overflow = 'visible';
    }
  }, [createModalStatus, startTrialStatus]);
  const getAgencies = () => {
    getAgency({
      page: currentPage, 
      search: debouncedSearchValue,
      inspections_revision: inspectionsRevisionFilter?.value || '', 
      corporate_id: corporateIdFilter?.value || '', 
      inspection_enabled: inspectionEnabledFilter?.value || '', 
      custom_inspections_enabled: customInspectionsEnabledFilter?.value || ''
    });
  };
  function base64ToBlob(base64Data) {
    const contentType = base64Data.substring(5, base64Data.indexOf(';'));
    const byteCharacters = atob(
      base64Data.substring(base64Data.indexOf(',') + 1),
    );
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {type: contentType});
  }

  const getCropData = () => {
    if (typeof cropper !== 'undefined') {
      const image = base64ToBlob(cropper.getCroppedCanvas().toDataURL());
      setShowModal(false);
      document.querySelector('.modal-fbo').style.display = 'flex';
      setPhoto(cropper.getCroppedCanvas().toDataURL());
      setImageBlob(image);
    }
  };

  const handlePageClick = page => {
    setCurrentPage(page.selected + 1);
    window.scrollTo(0, 0);
  };

  const handleEmail = e => {
    setEmail(e.target.value);
  };

  const handleSubmitInvite = () => {
    if (validationEmail(email)) {
      invite({email: email, role_id: 2});
    } else {
      toast.error(t('agency.messages.enterCorrectEmail'));
    }
  };

  const handleSubmitStart = () => {
    if (inspectionStart) {
      enableInspections({
        agency_id: currentItem?.id.toString(),
        start_date: inspectionStart,
        status: 1,
      })
        .unwrap()
        .then(res => {
          toast.success(res.message);
          setStartTrialStatus(false);
          setInspectionStart(null);
          getAgencies();
        });
    } else {
      toast.error(t('agency.messages.selectStartDate'));
    }
  };

  const renderTurnOffInspection = () => {
    return (
      <div className='modal'>
        <div className='modal__content'>
          <div className='modal__content-head'>
            <p>{t('agency.modals.turnOffInspections.title')}</p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => setTurnOffStatus(false)}
            />
          </div>
          <div
            className='modal__content-body'
            style={{display: 'flex', justifyContent: 'center'}}
          >
            {t('agency.modals.turnOffInspections.message')}
          </div>
          <div className='modal__content-bottom'>
            <button
              className='save danger '
              onClick={() => {
                enableInspections({
                  agency_id: currentItem?.id.toString(),
                  status: 0,
                })
                  .unwrap()
                  .then(res => {
                    toast.success(res.message);
                    setTurnOffStatus(false);
                    getAgencies();
                  })
                  .catch(err => {});
              }}
            >
              {t('agency.modals.turnOffInspections.turnOff')}
            </button>
            <button
              className='close almost'
              onClick={() => {
                setTurnOffStatus(false);
              }}
            >
              {t('actions.cancel')}
            </button>
          </div>
        </div>
        <div className='modal__bg'></div>
      </div>
    );
  };

  return (
    <Wrapper>
      <Helmet>
        <title>{t('agency.pageTitle')}</title>
      </Helmet>
      {inviteModal && (
        <div className='modal'>
          <div className='modal__content'>
            <div className='modal__content-head'>
              <p>{t('agency.modals.inviteFbo.title')}</p>
              <img
                className='modal__content-exit'
                src='/assets/icons/close.svg'
                alt='close'
                onClick={() => setInviteModal(false)}
              />
            </div>
            <div className={`modal__content-body`}>
              <Input
                containerWidth={'100%'}
                id='enail'
                name='emal'
                placeholder={t('agency.modals.inviteFbo.emailPlaceholder')}
                label={t('agency.modals.inviteFbo.email')}
                type={'email'}
                onChange={handleEmail}
                defaultValue=''
              />
            </div>
            <div className='modal__content-bottom'>
              <button className='close' onClick={() => setInviteModal(false)}>
                {t('actions.cancel')}
              </button>
              <button className='save' onClick={handleSubmitInvite}>
                {t('agency.modals.inviteFbo.sendLink')}
              </button>
            </div>
          </div>
          <div className='modal__bg'></div>
        </div>
      )}
      {editPrisingModal && (
        <EditPricingModal
          exit={() => setEditPrisingModal(false)}
          currentItem={currentItem}
          getAgencies={getAgencies}
        />
      )}
      {startTrialStatus && (
        <div className='modal'>
          <div className='modal__content'>
            <div className='modal__content-head'>
              <p>{t('agency.modals.turnOnInspections.title')}</p>
              <img
                className='modal__content-exit'
                src='/assets/icons/close.svg'
                alt='close'
                onClick={() => setStartTrialStatus(false)}
              />
            </div>
            <div className='modal__content-body'>
              <div className='modal__content-trial'>
                <p className='trial__modal-title'>{t('agency.modals.turnOnInspections.startDate')}</p>
                <Datepicker
                  width={440}
                  setValue={e => {
                    if (e !== 'Invalid Date' && e !== null) {
                      setInspectionStart(moment(e).format('YYYY-MM-DD'));
                    } else {
                      setInspectionStart(null);
                    }
                  }}
                  value={inspectionStart}
                />
              </div>
            </div>
            <div className='modal__content-bottom'>
              <button
                className='close'
                onClick={() => {
                  setStartTrialStatus(false);
                  setInspectionStart(null);
                }}
              >
                {t('actions.close')}
              </button>
              <button className='save' onClick={handleSubmitStart}>
                {t('agency.modals.turnOnInspections.confirm')}
              </button>
            </div>
          </div>
          <div className='modal__bg'></div>
        </div>
      )}
      {turnOffStatus && renderTurnOffInspection()}
      {showModal && (
        <div className='p-modal'>
          <div className='p-modal__content'>
            <div className='p-modal__header'>
              <p></p>
              <h5 className='p-modal__title'>{t('agency.modals.cropImage.title')}</h5>
              <div className='p-modal__close'>
                <img
                  src='/assets/icons/close.svg'
                  alt='close'
                  onClick={() => {
                    setShowModal(false);
                    setChosenPhoto(null);
                    document.querySelector('.modal-fbo').style.display = 'flex';
                  }}
                />
              </div>
            </div>
            <div className='p-modal__cropper'>
              <Cropper
                style={{
                  height: 400,
                  width: '100%',
                }}
                zoomTo={0}
                initialAspectRatio={1}
                preview='.img-preview'
                src={chosenPhoto}
                aspectRatio={1}
                viewMode={0}
                minCropBoxHeight={300}
                minCropBoxWidth={300}
                background={false}
                responsive={true}
                autoCropArea={1}
                checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                onInitialized={instance => {
                  setCropper(instance);
                }}
                guides={true}
              />
            </div>
            <div className='p-modal__btns'>
              <label
                htmlFor='profile_photo'
                className='profile__imageBox-upload'
              >
                {t('agency.modals.cropImage.changePhoto')}
              </label>
              <div className='profile__imageBox-upload' onClick={getCropData}>
                {t('agency.modals.cropImage.savePhoto')}
              </div>
            </div>
          </div>
          <div
            className='p-modal__bg'
            // onClick={() => {
            //   setShowModal(false);
            //   setChosenPhoto(null);
            //   document.querySelector('.modal-fbo').style.display = 'flex'
            // }}
          ></div>
        </div>
      )}
      {createModalStatus && (
        <Modal
          title={t('agency.modals.createFbo.title')}
          currentItem={currentItem}
          setCurrentItem={setCurrentItem}
          setShowModal={setShowModal}
          setChosenPhoto={setChosenPhoto}
          photo={photo}
          setCreateModalStatus={setCreateModalStatus}
          imageBlob={imageBlob}
          setPhoto={setPhoto}
          type='agancy'
          exit={() => {
            setCreateModalStatus(false);
            setPhoto(null);
            setImageBlob(null);
            setCurrentItem(null);
          }}
          getAgencies={getAgencies}
          timezones={timezonesData?.data?.map(item => ({
            value: item,
            label: item,
          }))}
          waterKitData={waterKitData?.map(item => ({
            label: item?.name,
            value: item?.id,
          }))}
        />
      )}
      <DashboardHeader
        title={t('agency.title')}
        showBtn={true}
        type='agancy-trial'
        action={() => setInviteModal(true)}
        secondAction={() => setCreateModalStatus(true)}
      />
      <div className='inspections agency new'>
        <div className='inspections__filters'>
          <Input
            bg={'white'}
            maxwidth={300}
            type='text'
            placeholder={t('agency.searchPlaceholder')}
            name='inspectionsSearch'
            id='inspectionsSearch'
            image={'/assets/icons/search.svg'}
            onChange={e => {
              setCurrentPage(1);
              setSearch(e.target.value);
            }}
          />
          <Select
            placeholder={t('agency.filters.inspectionsRevision')}
            options={revisionOptions}
            isClearable
            value={inspectionsRevisionFilter}
            onChange={setInspectionsRevisionFilter}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
                borderRadius: 8,
                minWidth: 200,
                height: 42,
              }),
              placeholder: (baseStyles) => ({
                ...baseStyles,
                color: '#9CA3AF',
                fontSize: '14px',
                fontWeight: 400,
              }),
              singleValue: (baseStyles) => ({
                ...baseStyles,
                color: '#718096',
                fontSize: '14px',
              }),
            }}
          />
          <Select
            placeholder={t('agency.filters.corporateId')}
            options={corporateListData?.map(item => ({value: item?.id, label: item?.title}))}
            isClearable
            value={corporateIdFilter}
            onChange={setCorporateIdFilter}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
                borderRadius: 8,
                minWidth: 200,
                height: 42,
              }),
              placeholder: (baseStyles) => ({
                ...baseStyles,
                color: '#9CA3AF',
                fontSize: '14px',
                fontWeight: 400,
              }),
              singleValue: (baseStyles) => ({
                ...baseStyles,
                color: '#718096',
                fontSize: '14px',
              }),
            }}
          />
          <Select
            placeholder={t('agency.filters.inspectionEnabled')}
            options={enabledOptions}
            isClearable
            value={inspectionEnabledFilter}
            onChange={setInspectionEnabledFilter}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
                borderRadius: 8,
                minWidth: 200,
                height: 42,
              }),
              placeholder: (baseStyles) => ({
                ...baseStyles,
                color: '#9CA3AF',
                fontSize: '14px',
                fontWeight: 400,
              }),
              singleValue: (baseStyles) => ({
                ...baseStyles,
                color: '#718096',
                fontSize: '14px',
              }),
            }}
          />
          <Select
            placeholder={t('agency.filters.customInspectionsEnabled')}
            options={enabledOptions}
            isClearable
            value={customInspectionsEnabledFilter}
            onChange={setCustomInspectionsEnabledFilter}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
                borderRadius: 8,
                minWidth: 200,
                height: 42,
              }),
              placeholder: (baseStyles) => ({
                ...baseStyles,
                color: '#9CA3AF',
                fontSize: '14px',
                fontWeight: 400,
              }),
              singleValue: (baseStyles) => ({
                ...baseStyles,
                color: '#718096',
                fontSize: '14px',
              }),
            }}
          />
        </div>
        <div className='inspectionsForm__box'>
          <div className='inspectionsForm__table new'>
            {list?.length ? (
              list?.map(agancy => (
                <AgencyTableCard
                  agancy={agancy}
                  currentItem={currentItem}
                  corporateData={corporateListData}
                  setTurnOffStatus={setTurnOffStatus}
                  setCurrentItem={setCurrentItem}
                  setCreateModalStatus={setCreateModalStatus}
                  getAgencies={getAgencies}
                  key={agancy?.id}
                  setList={setList}
                  setStartTrialStatus={setStartTrialStatus}
                  setEditPrisingModal={setEditPrisingModal}
                />
              ))
            ) : (
              <div className='emptyList'>
                <img src='/assets/empty-list.png' alt='empty' />
                <p>{t('agency.messages.noData')}</p>
              </div>
            )}
          </div>
          {list?.length ? (
            <CustomPaginate
              pageCount={agencyData?.pages}
              handlePageClick={handlePageClick}
            />
          ) : null}
        </div>
      </div>
    </Wrapper>
  );
}
